import { useEffect } from 'react';
import Confetti from './Confetti';
import RepTrophy from './RepTrophy';
import GradientPill from './GradientPill';
import { tierForReputation } from '../utils/reputation';

// Full-screen tier-up celebration. Trophy springs in, title fades up,
// confetti fires above. Dismissable by tapping Continue or the
// backdrop. Mounted by TierUpListener whenever a tier_up notification
// arrives.
export default function TierUpOverlay({ visible, reputation = 0, delta = 0, tier, onClose }) {
  useEffect(() => {
    if (!visible) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [visible, onClose]);

  if (!visible) return null;
  const t = tier || tierForReputation(reputation);
  const glow = t.color.glow;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 220,
        background: `linear-gradient(180deg, ${glow} 0%, rgba(8,6,14,0.95) 60%, rgba(8,6,14,0.98))`,
        backdropFilter: 'blur(14px)',
        display: 'grid', placeItems: 'center',
        animation: 'og-tierup-fade 280ms ease-out forwards'
      }}
    >
      <Confetti active />
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          padding: '32px 28px',
          textAlign: 'center',
          maxWidth: 360,
          animation: 'og-tierup-rise 700ms cubic-bezier(.16,1,.3,1) forwards'
        }}
      >
        <div style={{ display: 'grid', placeItems: 'center', marginBottom: 16, animation: 'og-trophy-pop 700ms cubic-bezier(.16,1.4,.3,1)' }}>
          <RepTrophy value={reputation} size={120} />
        </div>
        <p className="eyebrow" style={{ color: t.color.fg, marginBottom: 6 }}>TIER UP</p>
        <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 28, margin: '0 0 6px' }}>
          {t.title}
        </h2>
        <p className="muted" style={{ margin: '0 0 20px' }}>
          {delta > 0 ? `+${delta} reputation · ` : ''}You're now {t.badgeLabel}.
        </p>
        <GradientPill label="Continue" onClick={onClose} size="lg" />
      </div>
      <style>{`
        @keyframes og-tierup-fade { from { opacity: 0; } to { opacity: 1; } }
        @keyframes og-tierup-rise { from { opacity: 0; transform: translateY(28px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes og-trophy-pop { from { opacity: 0; transform: scale(0.4) rotate(-12deg); } to { opacity: 1; transform: scale(1) rotate(0deg); } }
      `}</style>
    </div>
  );
}
